import About from "./Components/About/About.js";
import Expertise from "./Components/Expertise/Expertise.js";
import Footer from "./Components/Footer/Footer.js";
import Header from "./Components/Header/Header.js";
import Home from "./Components/Home/Home.js";
import Navbar from "./Components/Navbar/Navbar.js";

import { BrowserRouter, Route, Routes } from "react-router-dom";
import Team from "./Components/Team/Team.js";
import Contact from "./Components/Contact/Contact.js";
import Portfolio from "./Components/Portfolio/Portfolio.js";

function App() {
  return (
  <BrowserRouter>
    <div className="App">
      <Header />
      <Navbar />
        <Routes>
          <Route path="/" element={<Home />}></Route>
          <Route path="/about" element={<About />}></Route>
          <Route path="/expertise" element={<Expertise />}></Route>
          <Route path="/team" element={<Team />}></Route>
          <Route path="/portfolio" element={<Portfolio />}></Route>
          <Route path="/contact" element={<Contact />}></Route>

        </Routes>
      <Footer />
    </div>
  </BrowserRouter>

  );
}

export default App;
